import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Vision from "@/components/Vision";
import LinePreviews from "@/components/LinePreviews";
import Lookbook from "@/components/Lookbook";
import WaitlistForm from "@/components/WaitlistForm";
import ApplicationForm from "@/components/ApplicationForm";
import ClosingCta from "@/components/ClosingCta";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_sanzone-launch/artifacts/hh1mh2ai_image.png";

export const scrollToId = (id) => {
  document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F4EEE3] text-[#221812] antialiased selection:bg-[#221812] selection:text-[#F4EEE3]">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Vision />
        <LinePreviews />
        <Lookbook />
        <WaitlistForm />
        <ApplicationForm />
        <ClosingCta />
      </main>
      <Footer />
      <Toaster theme="light" position="bottom-center" />
    </div>
  );
}

export default App;
